import { AIButton } from "@similarweb/ai-kit";
import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Stack, Text } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";
import { StyledAiHr } from "app/pages/sales-intelligence/modules/ai-agent/components/markdown-components";

import type { SuggestedQueriesData } from "../../../../../types/content";
import { SuggestedQueriesView } from "../SuggestedQueriesView";

export type SuggestedQueriesStrategyProps = {
    suggestions: SuggestedQueriesData;
    onSuggestionClick: (suggestionText: string) => void;
    onShowMoreClick: VoidFunction;
};

export const SuggestedQueriesStrategy = ({
    suggestions,
    onSuggestionClick,
    onShowMoreClick,
}: SuggestedQueriesStrategyProps) => {
    const list = Object.values(suggestions);

    return (
        <Stack>
            <Text
                fontVariant="h6"
                marginX="0 4px"
            >
                {translate("si.agent.leads.suggestions.message.title")}
            </Text>
            <Text
                fontVariant="input2"
                color={colorsPalettes.carbon[500]}
            >
                {translate("si.agent.leads.suggestions.message.description")}
            </Text>

            <StyledAiHr />

            <SuggestedQueriesView
                title={translate("si.agent.suggestions.quick-suggestions")}
                suggestions={list}
                onSuggestionClick={onSuggestionClick}
            >
                <AIButton
                    variant="ghost"
                    icon={
                        <SWReactIcons
                            iconName="sparkles-ai"
                            size="xs"
                        />
                    }
                    label={translate("si.agent.suggestions.get-more-ideas")}
                    onClick={onShowMoreClick}
                />
            </SuggestedQueriesView>
        </Stack>
    );
};
